// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Client from "@apollo/client";
import * as StockTransferForm from "./StockTransferForm.res.js";
import * as ReactUpdateReducer from "../../primitives/ReactUpdateReducer.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query VariantsByCkuQuery($cku: CKU!, $filterBy: InputVariantsByCkuQueryFilter)  {\nvariantsByCku(cku: $cku, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nstock  {\n__typename  \nrawQuantity  \nstate  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  return {
    variantsByCku: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.stock;
        let value$3 = value$2.rawQuantity;
        let value$4 = value$2.state;
        let tmp;
        if (value$4 == null) {
          tmp = undefined;
        } else {
          let tmp$1;
          switch (value$4) {
            case "ALERT" :
              tmp$1 = "ALERT";
              break;
            case "DANGER" :
              tmp$1 = "DANGER";
              break;
            case "OK" :
              tmp$1 = "OK";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = tmp$1;
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            stock: {
              __typename: value$2.__typename,
              rawQuantity: !(value$3 == null) ? value$3 : undefined,
              state: tmp
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.variantsByCku;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.stock;
    let value$3 = value$2.state;
    let state = value$3 !== undefined ? (
        value$3 === "OK" ? "OK" : (
            value$3 === "ALERT" ? "ALERT" : "DANGER"
          )
      ) : null;
    let value$4 = value$2.rawQuantity;
    let rawQuantity = value$4 !== undefined ? value$4 : null;
    let value$5 = value$2.__typename;
    let stock = {
      __typename: value$5,
      rawQuantity: rawQuantity,
      state: state
    };
    let value$6 = value$1.id;
    let value$7 = value$1.__typename;
    let node = {
      __typename: value$7,
      id: value$6,
      stock: stock
    };
    let value$8 = value.__typename;
    return {
      __typename: value$8,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let variantsByCku = {
    __typename: value$3,
    edges: edges
  };
  return {
    variantsByCku: variantsByCku
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeInputObjectInputVariantsByCkuQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.active;
  let a$2 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    active: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    archived: a$2 !== undefined ? (
        a$2 === "ONLY" ? "ONLY" : (
            a$2 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    cku: inp.cku,
    filterBy: a !== undefined ? serializeInputObjectInputVariantsByCkuQueryFilter(a) : undefined
  };
}

function makeVariables(cku, filterBy, param) {
  return {
    cku: cku,
    filterBy: filterBy
  };
}

function makeInputObjectInputVariantsByCkuQueryFilter(shopIds, active, archived, param) {
  return {
    shopIds: shopIds,
    active: active,
    archived: archived
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

let VariantsByCkuQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsByCkuQueryFilter: serializeInputObjectInputVariantsByCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsByCkuQueryFilter: makeInputObjectInputVariantsByCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let VariantsByCkuQuery_refetchQueryDescription = include.refetchQueryDescription;

let VariantsByCkuQuery_use = include.use;

let VariantsByCkuQuery_useLazy = include.useLazy;

let VariantsByCkuQuery_useLazyWithVariables = include.useLazyWithVariables;

let VariantsByCkuQuery = {
  VariantsByCkuQuery_inner: VariantsByCkuQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsByCkuQueryFilter: serializeInputObjectInputVariantsByCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsByCkuQueryFilter: makeInputObjectInputVariantsByCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  refetchQueryDescription: VariantsByCkuQuery_refetchQueryDescription,
  use: VariantsByCkuQuery_use,
  useLazy: VariantsByCkuQuery_useLazy,
  useLazyWithVariables: VariantsByCkuQuery_useLazyWithVariables
};

function getVariantByCkuAndShopId(client, cku, shopId) {
  return Future.map(FuturePromise.fromPromise(client.rescript_query({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize,
    serializeVariables: serializeVariables
  }, undefined, undefined, "NetworkOnly", undefined, {
    cku: Scalar.CKU.serialize(cku),
    filterBy: {
      shopIds: {
        _in: [shopId]
      },
      active: undefined,
      archived: undefined
    }
  })), undefined, results => {
    if (results.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let match = results._0;
    if (match.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let match$1 = match._0;
    if (match$1.error !== undefined) {
      return {
        TAG: "Error",
        _0: undefined
      };
    } else {
      return {
        TAG: "Ok",
        _0: match$1.data.variantsByCku.edges
      };
    }
  });
}

let initialState_products = [];

let initialState = {
  processing: false,
  products: initialState_products
};

function reducer(client, recipientShopId, state, action) {
  if (typeof action !== "object") {
    if (action === "ResetRequested") {
      return {
        TAG: "Update",
        _0: initialState
      };
    } else {
      return {
        TAG: "Update",
        _0: {
          processing: false,
          products: state.products
        }
      };
    }
  }
  switch (action.TAG) {
    case "ProductBulkAddRequested" :
      return {
        TAG: "UpdateWithSideEffects",
        _0: {
          processing: state.processing,
          products: action._0.concat(state.products)
        },
        _1: self => {
          self.dispatch({
            TAG: "ProductRecipientStockAndIdBulkFetchRequested",
            _0: recipientShopId
          });
        }
      };
    case "ProductRemoveRequested" :
      let cku = action._0;
      return {
        TAG: "Update",
        _0: {
          processing: state.processing,
          products: state.products.filter(product => product.cku !== cku)
        }
      };
    case "ProductUpdateRequested" :
      let update = action._1;
      let cku$1 = action._0;
      return {
        TAG: "Update",
        _0: {
          processing: state.processing,
          products: state.products.map(product => {
            if (product.cku === cku$1) {
              return update(product);
            } else {
              return product;
            }
          })
        }
      };
    case "ProductTransferredQuantityUpdateRequested" :
      let transferredQuantity = action._1;
      let cku$2 = action._0;
      return {
        TAG: "Update",
        _0: {
          processing: state.processing,
          products: state.products.map(product => {
            if (product.cku === cku$2) {
              return {
                cku: product.cku,
                name: product.name,
                description: product.description,
                purchasePrice: product.purchasePrice,
                stockKeepingUnit: product.stockKeepingUnit,
                senderVariantId: product.senderVariantId,
                senderStockQuantity: product.senderStockQuantity,
                senderStockState: product.senderStockState,
                recipientVariantId: product.recipientVariantId,
                recipientStockQuantity: product.recipientStockQuantity,
                recipientStockState: product.recipientStockState,
                transferredQuantity: transferredQuantity
              };
            } else {
              return product;
            }
          })
        }
      };
    case "ProductRecipientStockAndIdBulkFetchRequested" :
      let shopId = action._0;
      return {
        TAG: "UpdateWithSideEffects",
        _0: {
          processing: true,
          products: state.products.map(product => ({
            cku: product.cku,
            name: product.name,
            description: product.description,
            purchasePrice: product.purchasePrice,
            stockKeepingUnit: product.stockKeepingUnit,
            senderVariantId: product.senderVariantId,
            senderStockQuantity: product.senderStockQuantity,
            senderStockState: product.senderStockState,
            recipientVariantId: product.recipientVariantId,
            recipientStockQuantity: undefined,
            recipientStockState: product.recipientStockState,
            transferredQuantity: product.transferredQuantity
          }))
        },
        _1: self => {
          let updatingRecipientStocksAndIds = self.state.products.map(product => Future.mapOk(getVariantByCkuAndShopId(client, product.cku, shopId), undefined, results => {
            if (results.length !== 1) {
              return;
            }
            let result = results[0];
            self.dispatch({
              TAG: "ProductUpdateRequested",
              _0: product.cku,
              _1: productToUpdate => ({
                cku: productToUpdate.cku,
                name: productToUpdate.name,
                description: productToUpdate.description,
                purchasePrice: productToUpdate.purchasePrice,
                stockKeepingUnit: productToUpdate.stockKeepingUnit,
                senderVariantId: productToUpdate.senderVariantId,
                senderStockQuantity: productToUpdate.senderStockQuantity,
                senderStockState: productToUpdate.senderStockState,
                recipientVariantId: result.node.id,
                recipientStockQuantity: result.node.stock.rawQuantity,
                recipientStockState: result.node.stock.state,
                transferredQuantity: productToUpdate.transferredQuantity
              })
            });
          }));
          Future.get(Future.all(updatingRecipientStocksAndIds), param => self.dispatch("ProductRecipientStockAndIdBulkFetchSucceeded"));
        }
      };
  }
}

function use() {
  let client = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let match = StockTransferForm.useFormState();
  let status = match.status;
  let formDispatch = StockTransferForm.useFormDispatch();
  let recipientShopId = match.values.recipientShopId;
  let match$1 = ReactUpdateReducer.use((state, action) => reducer(client, recipientShopId, state, action), initialState);
  let productsDispatch = match$1[1];
  let productsState = match$1[0];
  React.useEffect(() => {
    if (!productsState.processing && status !== "Pristine") {
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "Products",
        _1: param => productsState.products.map(product => ({
          quantity: product.transferredQuantity,
          senderVariantId: product.senderVariantId,
          recipientVariantId: product.recipientVariantId
        }))
      });
    }
  }, [productsState]);
  React.useEffect(() => {
    if (status === "Pristine") {
      productsDispatch("ResetRequested");
    }
  }, [status]);
  return [
    productsState,
    productsDispatch
  ];
}

export {
  VariantsByCkuQuery,
  getVariantByCkuAndShopId,
  initialState,
  reducer,
  use,
}
/* query Not a pure module */
